// @flow

export const DEFAULT_LOCALE = 'en-US';
// Use `navigator.language` for dynamic locale
export const LOCALE = navigator.language || DEFAULT_LOCALE;
